/**
 * Get the users current Location
 * @param window
 */

import { LatLng } from 'src/components/GoogleMaps/GoogleMapsTypes';

function getCurrentLocation(): Promise<LatLng> {
    return new Promise((resolve, reject) => {
        // Browser doesn't support geolocation
        if (!window.navigator.geolocation) {
            reject('Geolocation is not supported by this browser.');
            return;
        }

        // If successful
        function success(position) {
            resolve({ lat: position.coords.latitude, lng: position.coords.longitude });
        }

        // If there was an error (user didn't allow access)
        function error() {
            reject(
                "Sorry we could not use your current location at this time - please ensure it's enabled in your browser",
            );
        }

        window.navigator.geolocation.getCurrentPosition(success, error);
    });
}

export { getCurrentLocation };
